import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth-service';

@Injectable()
export class AppGuardAdmin implements CanActivate {
    constructor(private router: Router, private authService: AuthService) {}

    canActivate(
        route: ActivatedRouteSnapshot
        ): boolean | Observable<boolean> | Promise<boolean> {
            return this.authService.isAdmin
            .map(
                (isAdmin: boolean) => {
                    console.log(isAdmin);

                    if (!isAdmin ) {
                        this.router.navigate(['/login']);
                        return false;
                    }
                    return true;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/app-guard-admin.ts